(function () {
  if (window.sasMenuUtilityTrackingReady) return;
  window.sasMenuUtilityTrackingReady = true;

  var CONTAINER_SELECTOR = '[data-sas-utility-location]';
  var STORAGE_KEY = 'sas_menu_utility_tracked';
  var memoryTracked = {};

  function wasTracked(key) {
    if (memoryTracked[key]) return true;
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      return !!stored[key];
    } catch (err) {
      return false;
    }
  }

  function markTracked(key) {
    memoryTracked[key] = true;
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      stored[key] = true;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (err) {
      console.warn('[sas-menu-utility] sessionStorage unavailable, deduping in memory only (until the page reloads):', err);
    }
  }

  function getType(link) {
    if (link.matches('a[href^="tel:"]')) return 'call';
    if (link.closest('[data-sas-track="appointment"]')) return 'appointment';
    if (link.closest('[data-sas-track="stores"]')) return 'stores';
    return null;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest(CONTAINER_SELECTOR + ' a, ' + CONTAINER_SELECTOR + ' button');
    if (!link) return;

    var type = getType(link);
    if (!type) return;

    var location = link.closest(CONTAINER_SELECTOR).getAttribute('data-sas-utility-location');

    var payload = {
      event: 'sas_menu_' + type + '_click',
      sas_location: location,
      sas_link_text: (link.textContent || '').replace(/\s+/g, ' ').trim()
    };

    if (type === 'call') {
      payload.sas_phone_number = (link.getAttribute('href') || '').replace('tel:', '');
    } else if (link.getAttribute('href')) {
      payload.sas_link_url = link.getAttribute('href');
    }

    var trackKey = [payload.event, location, payload.sas_phone_number || payload.sas_link_url || payload.sas_link_text].join('|');
    if (wasTracked(trackKey)) {
      return;
    }
    markTracked(trackKey);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  
  });
})();
